define('uikit/elements/label',['require','exports','module','underscore','marionette','../mixins/component.mixin','../channel','templates','../extra/size','../extra/color'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Templates = require('templates');
  var Size = require('../extra/size');
  var Color = require('../extra/color');

  var LabelView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui label',

    allowTagChange: true,

    options: {
      visible    : true,
      text       : '',
      link       : '', //set href here
      detail     : '',
      icon       : null,
      pointing   : null, // below left right above
      prompt     : false,
      attached   : null, //top, top right, bottom, bottom right, etc.
      horizontal : false,
      floating   : false,
      color      : '',
      size       : '',
      circular   : false,
      tag        : false,
      empty      : false,
      ribbon     : false,
      wrappable  : false,
      closeable  : false,
      title      : ''
    },

    pointingOptionValues: [
      'below',
      'left',
      'right',
      'above'
    ],
    attachedOptionValues: [
      'top',
      'top right',
      'bottom',
      'bottom right',
    ],

    ui: {
      detail: '.detail',
      text: '.text'
    },
    
    sizeOptionValues: _.values(Size),
    colorOptionValues: _.values(Color),

    forceUpdate: {
      closeable: true
    },

    events: {
      'click i.close.icon' : function() { this.triggerMethod('close'); },
      'keydown i.close.icon' : function(ev) { if (ev.keyCode == 13) { this.triggerMethod('close'); } }
    },

    updateAttributes: function() {
      this
        .addClass("icon", this.getBoolOption("icon") && !this.getBoolOption('text'))
        .addClass("floating", this.getBoolOption("floating"))
        .addClass("circular", this.getBoolOption("circular"))
        .addClass("tag", this.getBoolOption("tag"))
        .addClass(this.getOption("attached"), this.getBoolOption("attached"))
        .addClass("horizontal", this.getBoolOption("horizontal"))
        .addClass("pointing", this.getBoolOption("pointing"))
        .addClass("prompt", this.getBoolOption("prompt"))
        .addClass("empty", this.getBoolOption("empty"))
        .addClass("ribbon", this.getBoolOption("ribbon"))
        .addClass('wrappable', this.getBoolOption('wrappable'))
        .addClass(this.getOption("pointing"), this.getBoolOption("pointing"))
        .addClass(this.getOption('color'))
        .addClass(this.getOption('size'));

      if (this.getOption('link')) {
        this.$el.attr('href', this.getOption('link'))
      } else {
        this.$el.removeAttr('href');
      }

      if (this.title) {
        this.$el.attr('title', this.title);
      } else {
        this.$el.removeAttr('title');
      }

      if (this.ui.detail) {
        this.ui.detail.text(this.getOption('detail'));
      }
      if (this.ui.text) {
        this.ui.text.text(this.getOption('text'));
      }
    },

    template: Templates.App['label']

  });

  // register the table component
  channel.reply('label', function() {
    return LabelView;
  });

  module.exports = LabelView;
});
